import { Component, OnDestroy, OnInit } from "@angular/core";
import { SPHERE_EDIT_SELECTOR } from "../../../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../../../base/base.component";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { NurseryManager } from "../../../../../business/managers/nursery.manager";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import {
    PRIVATE_NURSERY_MAP_ROUTE
} from "../../../../../crossconcern/utilities/properties/routename.property";
import { Subscription } from "rxjs";

@Component({
    selector: SPHERE_EDIT_SELECTOR,
    templateUrl: "./sphereedit.component.html"
})
export class SphereEditComponent extends BaseComponent implements OnInit, OnDestroy {

    public nurseryUUID = "";
    public sphereUUID = "";

    private onGoBackCalledSubscription: Subscription;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected genericService: GenericService,
        private nurseryManager: NurseryManager,
        private activeRoute: ActivatedRoute,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    public ngOnInit(): void {
        this.activeRoute.params.subscribe(
            (params) => {
                this.nurseryUUID = params.id;
            }
        );
        this.activeRoute.queryParams.subscribe(
            (params) => {
                this.sphereUUID = params.start;
            }
        );

        this.subscribeGenericServices();
    }

    public ngOnDestroy() {
        this.unsubscribeServices();
    }

    private subscribeGenericServices() {
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(() => {
            this.goToRouteByName(PRIVATE_NURSERY_MAP_ROUTE, { id: this.nurseryUUID });
        });
    }

    private unsubscribeServices() {
        if(this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    }
}